import { useQuery } from 'react-query';
import {
  getCastRelationshipById,
  type CastRelationshipResponse
} from '../../services/castRelationshipService';

export function useGetCastRelationshipById(castRelationshipId: string) {
  return useQuery<CastRelationshipResponse, Error, CastRelationshipResponse>(
    ['castRelationship', castRelationshipId],
    () => getCastRelationshipById({ castRelationshipId }),
    {
      enabled: !!castRelationshipId
    }
  );
}
